import { assertPlatform, Component, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective, ModalOptions } from 'ngx-bootstrap/modal';
import { AlarmConfig, DistributionList, MessageTemplate, TimeSeriesAlarm } from 'src/api/models';
import { TimeSeriesAlarmService, CustomerService, DistributionListService, MessageTemplateService } from 'src/api/services';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-alarm-editor',
  templateUrl: './alarm-editor.component.html',
  styleUrls: ['./alarm-editor.component.scss']
})
export class AlarmEditorComponent implements OnInit {
  @ViewChild('ruleModal', { static: false }) modal: ModalDirective;
  //@Input()
  uri: string;
  //@Input() showButton: boolean = false;
  alarms: TimeSeriesAlarm[];
  todelete: TimeSeriesAlarm[];
  distributionLists: DistributionList[];
  messageTemplates: MessageTemplate[];

  constructor(public service: TimeSeriesAlarmService,
    private distribution: DistributionListService, 
    private mtService: MessageTemplateService,
    private app: ApplicationConfigService, 
    private toasterService: ToastrService) {
      this.todelete = [];
  }

  ngOnInit() {
  }

  closeModal(){
    this.modal.hide();
  }

  isNumber(rule){
    return typeof rule.match == 'number';
  }

  public openModal(uri: string){
    this.alarms = null;
    this.distributionLists = null;
    this.messageTemplates = null;
    
    this.uri = uri;
    this.modal.show();
    
    this.distribution.DistributionListGetDistributionLists(this.app.customerId).subscribe(dl => {
      this.distributionLists = dl;
    });
    this.mtService.MessageTemplateGetMessageTemplates(this.app.customerId).subscribe(mt => {
      this.messageTemplates = mt;
    });
    this.service.TimeSeriesAlarmGetByUri({uri: this.uri, customerId: this.app.customerId }).subscribe(a => {
      console.log('alarms',a);
      if (a == null){
        a = [];
      }
      this.alarms = a;
      this.todelete = [];
    });
  }

  saveAlarms(){
    for (let alarm of this.alarms){
      if (alarm.timeSeriesAlarmId){
        this.service.TimeSeriesAlarmUpdate(alarm).subscribe(a => {
          this.toasterService.success("Updated","Alarm");
          this.modal.hide();
        }, e => {
          this.toasterService.error("Not Updated","Alarm");
        });
      } else {
        this.service.TimeSeriesAlarmCreate(alarm).subscribe(a => {
          a.createdBy = a.createdBy;
          a.timeSeriesAlarmId = a.timeSeriesAlarmId;
          this.toasterService.success("Created","Alarm");
          this.modal.hide();
        }, e => {
          this.toasterService.error("Not Created","Alarm");
        });
      }
    }
    for (let alarm of this.todelete){
      this.service.TimeSeriesAlarmDelete({timeSeriesAlarmId: alarm.timeSeriesAlarmId, customerId: this.app.customerId}).subscribe(a => {
        this.toasterService.success("Deleted","Alarm");
        this.modal.hide();
      }, e => {
        this.toasterService.error("Not Deleted","Alarm");
      });
    }
  }

  public addNewAlarm(){
    this.alarms.push({uri:this.uri, customerId: this.app.customerId, alarmConfiguration:[{}],messageTemplateId:null} as TimeSeriesAlarm);
  } 

  public removeAlarm(alarm: TimeSeriesAlarm){
    var index = this.alarms.indexOf(alarm);
    //var a = this.alarms[index];
    this.todelete.push(alarm);
    this.alarms.splice(index, 1);
  }

  public removeRule(alarm: TimeSeriesAlarm, rule: AlarmConfig):void{
    var index = alarm.alarmConfiguration.indexOf(rule);
    alarm.alarmConfiguration.splice(index, 1);
  }

  
  public moveRuleUp(alarm: TimeSeriesAlarm, rule: AlarmConfig):void{
    var fromIndex = alarm.alarmConfiguration.indexOf(rule);
    var toIndex = Math.max(fromIndex - 1, 0)
    //this.rules.splice(index, 1);
    var element = alarm.alarmConfiguration[fromIndex];
    alarm.alarmConfiguration.splice(fromIndex, 1);
    alarm.alarmConfiguration.splice(toIndex, 0, element);
  }

  public moveRuleDown(alarm: TimeSeriesAlarm, rule: AlarmConfig):void{
    var fromIndex = alarm.alarmConfiguration.indexOf(rule);
    var toIndex = Math.min(fromIndex + 1, alarm.alarmConfiguration.length-1)
    //this.rules.splice(index, 1);
    var element = alarm.alarmConfiguration[fromIndex];
    alarm.alarmConfiguration.splice(fromIndex, 1);
    alarm.alarmConfiguration.splice(toIndex, 0, element);
  }


  public addNewRule(alarm: TimeSeriesAlarm):void{
    if (alarm.alarmConfiguration == null){
      alarm.alarmConfiguration = [];
    }
    var rule = {};
    alarm.alarmConfiguration.push(rule as AlarmConfig);
  }

  public validate() : boolean{
    for (let alarm of this.alarms){
      if (alarm.name == null || alarm.name == '' || alarm.distributionListId == null){
        return false;
      }
      for (let rule of alarm.alarmConfiguration){
        if (rule.name == null || rule.name == '' || rule.match == null || rule.check == null){
          return false;
        }
      }
    }
    return true;
  }
}
